import React, { useEffect, useState } from 'react';
import { UNDO_DURATION_MS } from './uiConfig';

/**
 * 削除したタスクがあった場所に、そのまま差し替えて表示する行。
 * 時間が過ぎるか、押されると消える。
 */
function UndoRow({ name, onUndo, onExpire }) {
  const [left, setLeft] = useState(UNDO_DURATION_MS);

  useEffect(() => {
    const started = Date.now();
    const id = setInterval(() => {
      const rest = UNDO_DURATION_MS - (Date.now() - started);
      if (rest <= 0) {
        clearInterval(id);
        onExpire();
      } else {
        setLeft(rest);
      }
    }, 100);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ratio = Math.max(0, left / UNDO_DURATION_MS);

  return (
    <div className="undo-row">
      <div className="undo-bar" style={{ width: `${ratio * 100}%` }} />
      <div className="undo-body">
        <span className="undo-text">「{name || '(無題)'}」を削除しました</span>
        <button className="undo-btn" onClick={onUndo}>
          ↩ 元に戻す
        </button>
      </div>
    </div>
  );
}

export default UndoRow;
